document.addEventListener("DOMContentLoaded", function () {
  const inspoAdviceCarousel = document.querySelector(
    ".hero-banner-carousel__swiper"
  );

  if (inspoAdviceCarousel) {
    const swiper = new Swiper(".hero-banner-carousel__swiper", {
      // Optional parameters
      direction: "horizontal",
      loop: true,
      effect: "slide",
      autoplay: { delay: 8000 },
      speed: 1000,
      autoHeight: true,
      keyboard: true,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 8,
      grabCursor: true,

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    swiper.on("slideChangeTransitionEnd", function () {
      var index = swiper.activeIndex;

      var currentSlide = swiper.slides[index];

      const vidya = currentSlide.querySelector("video");

      // if there is a video and it does not have the play attribute added
      if (
        vidya &&
        (!vidya.getAttribute("autoplay") || !vidya.getAttribute("playing"))
      ) {
        // then play!
        vidya.play();
        vidya.setAttribute("playing", true);
      }
    });
  }
});
